import { useQuery, } from "@tanstack/react-query";
import { limitsQueryConfig, } from "../../../../../api";
import { LimitsBlockView, } from "./LimitsBlockView.tsx";

export function LimitsBlockDefault() {
  const limits = useQuery(limitsQueryConfig({ statuses: "CONFIRMED", },),);

  const hasData = limits.isSuccess && limits.data.length > 0;
  const isLoading = limits.isLoading;

  return (
    <LimitsBlockView
      hasData={hasData}
      isLoading={isLoading}
      data={limits.data}
    />
  );
}
